import {Fragment} from "react";
import {TieredMenu} from "primereact/tieredmenu";

export default function NsMenuUtenteView({
                                             user,
                                             aggiornaLingua,
                                             isMobile,
                                             annoKpi,
                                             anni,
                                             refMenuUsr,
                                             onChangeAnno,
                                             onClickLogout,
                                     }) {

    return (
        <TieredMenu
            model={[
                {
                    template: <Fragment>
                        {
                            user &&
                            <div className="flex align-items-center gap-2">
                                <div className={"ns-info-user pt-2"}>
                                                <span className="pe-2">
                                                    <strong>{user.nome}&nbsp;{user.cognome}</strong>
                                                </span>
                                </div>
                                <div className={"ns-info-user"}>
                                                <span style={{
                                                    fontSize: "14px"
                                                }}>
                                                    {user.ruolo}
                                                </span>
                                </div>
                            </div>
                        }
                    </Fragment>
                },
                {
                    separator: true
                },
                {
                    template: <Fragment>
                        {
                            user &&
                            <div className="flex align-items-center gap-2">
                                <div
                                    className={"pt-2 pb-2"}
                                    style={{
                                        paddingLeft: "1.25rem",
                                        background: "#ffffff"
                                    }}
                                >
                                    <span
                                        className="pe-3 ns-mouse-pointer"
                                        onClick={() => aggiornaLingua('it')}
                                    >
                                        <i className="flag-icon flag-icon-it"/>
                                    </span>
                                    <span
                                        className="pe-3 ns-mouse-pointer"
                                        onClick={() => aggiornaLingua('en')}
                                    >
                                        <i className="flag-icon flag-icon-gb"/>
                                    </span>
                                </div>
                            </div>
                        }
                    </Fragment>
                },
                isMobile && {
                    separator: true
                },
                isMobile && {
                    template: <Fragment>
                        {
                            user &&
                            <div className="flex align-items-center gap-2">
                                <div
                                    className={"pt-2 pb-2"}
                                    style={{
                                        paddingLeft: "1.25rem",
                                        background: "#ffffff"
                                    }}
                                    onClick={(event) => {
                                        // Impedisce la propagazione dell'evento di click permettendomi di aprire la select
                                        event.stopPropagation();
                                    }}
                                >
                                    <select
                                        className={"form-select-sm me-3"}
                                        value={annoKpi}
                                        onChange={onChangeAnno}
                                    >
                                        {
                                            anni && anni.map((anno) =>
                                                <option key={anno} value={anno}>{anno}</option>
                                            )
                                        }
                                    </select>
                                </div>
                            </div>
                        }
                    </Fragment>
                },
                {
                    separator: true
                },
                {
                    label: 'Logout',
                    icon: 'pi pi-sign-out',
                    command: onClickLogout
                }
            ].filter(b => b)}
            popup
            ref={refMenuUsr}
            breakpoint="767px"
        />
    );
}